import {Box, HStack, Show, VStack} from 'platform/foundation';

import {useGetParticipationQuery} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import {testIds} from '@dms/routes';
import {
  CustomerInformationCard,
  CustomerContactPersonCard,
  Section,
  useCustomerUrl,
  EntityCustomFields,
  usePermissions,
  BoschFleetIntegrationCard,
} from '@dms/shared';

import {AddressesCard} from './components/AddressesCard';
import {CommentsCard} from './components/CommentsCard';
import {ContractInformationCard} from './components/ContractInformationCard';
import {NoteCard} from './components/NoteCard';
import {PaymentSettingsCard} from './components/PaymentSettingsCard';

export function CustomerInformation() {
  const {customerId} = useCustomerUrl();

  const {data: customerParticipation} = useGetParticipationQuery({
    recordId: customerId,
    resourceId: EntityResourceIds.customer,
  });

  const [canEditCustomFields, canReadServiceCase] = usePermissions({
    permissionKeys: ['customerCustomFields', 'serviceCaseRead'],
    scopes: {
      customerCustomFields: {
        participation: customerParticipation,
        // no branchId on customer
        branchId: 'SKIP',
      },
    },
  });

  const hasServiceCaseLicense = canReadServiceCase;

  return (
    <Section>
      <HStack spacing={4} justify="flex-start" align="flex-start">
        <Box flex={1}>
          <VStack spacing={4}>
            <CustomerInformationCard
              data-testid={testIds.customer.detail('detail')}
              customerId={customerId}
            />
            <ContractInformationCard
              data-testid={testIds.customer.detail('detail')}
              customerId={customerId}
            />
            <Show when={hasServiceCaseLicense}>
              <PaymentSettingsCard
                data-testid={testIds.customer.detail('paymentSettings')}
                customerId={customerId}
              />
            </Show>
            <EntityCustomFields
              recordId={customerId}
              resourceId={EntityResourceIds.customer}
              isEditable={canEditCustomFields}
              data-testid={testIds.customer.detail('customer-custom-fields')}
            />
            <Show when={hasServiceCaseLicense}>
              <BoschFleetIntegrationCard customerId={customerId} />
            </Show>
          </VStack>
        </Box>
        <Box flex={1}>
          <VStack spacing={4}>
            <CustomerContactPersonCard
              data-testid={testIds.customer.detail('detail')}
              customerId={customerId}
            />
            <AddressesCard
              data-testid={testIds.customer.detail('detail')}
              customerId={customerId}
            />
            <NoteCard data-testid={testIds.customer.detail('detail')} customerId={customerId} />
            <CommentsCard data-testid={testIds.customer.detail('detail')} customerId={customerId} />
          </VStack>
        </Box>
      </HStack>
    </Section>
  );
}
